import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BadUrlComponent } from './bad-url/bad-url.component';
import { SuccessPageComponent } from './eeoc/success-page/success-page.component';
import { JobPreferencesComponent } from './job-preferences/job-preferences.component';
import { JobPreferencesSuccessPageComponent } from './job-preferences/job-preferences-success-page/job-preferences-success-page.component';
import { AuthGuard } from './service/auth.guard';
import { LoginPageComponent } from './login-page/login-page.component';
import { AuthRequiredGuard } from './service/auth-required.guard';
import { EeocFormComponent } from './eeoc/eeoc-form/eeoc-form.component';
import { EeocFormUsComponent } from './eeoc/eeoc-form-us/eeoc-form-us.component';
import { PreferencesConfirmedPageComponent } from './preferences-confirmed-page/preferences-confirmed-page.component';
import { JobPreferencesReadOnlyComponent } from './job-preferences/job-preferences-read-only/job-preferences-read-only.component';
import { DoubleOptInConfirmComponent } from './talent-happy-path/double-opt-in-confirm/double-opt-in-confirm.component';
import { PreInterviewQuestionsComponent } from "./pre-interview-questions/pre-interview-questions.component";
import { AnswerPreInterviewQuestionsComponent } from "./pre-interview-questions/answer-pre-interview-questions/answer-pre-interview-questions.component";
import { ThankYouComponent } from "./talent-happy-path/thank-you/thank-you.component";
import { JobPostingClosedComponent } from "./talent-happy-path/job-posting-closed/job-posting-closed.component";
import { EmailCancellationComponent } from './talent-availability/email-cancellation/email-cancellation.component';
import { TalentHappyPathAuthResolver } from "./talent-happy-path/shared/service/talent-happy-path-auth.resolver";

const routes: Routes = [
  { path: 'login', component: LoginPageComponent, canActivate: [AuthGuard] },
  {
    path: 'eeoc-form/:uuid',
    component: EeocFormComponent
  },
  {
    path: 'eeoc-form-us',
    component: EeocFormUsComponent,
    canActivate: [AuthRequiredGuard]
  },
  {
    path: 'eeoc-form',
    component: EeocFormComponent,
    canActivate: [AuthRequiredGuard]
  },
  {
    path: 'eeoc/success',
    component: SuccessPageComponent
  },
  {
    path: 'job-preferences-confirm',
    component: JobPreferencesReadOnlyComponent,
    canActivate: [AuthRequiredGuard]
  },
  {
    path: 'job-preferences-form/:uuid/:redeploy',
    component: JobPreferencesComponent
  },
  {
    path: 'job-preferences-form/:uuid',
    component: JobPreferencesComponent
  },
  {
    path: 'job-preferences-form',
    component: JobPreferencesComponent,
    canActivate: [AuthRequiredGuard]
  },
  {
    path: 'job-preferences/success',
    component: JobPreferencesSuccessPageComponent
  },
  {
    path: 'preferences-confirmed/:uuid',
    component: PreferencesConfirmedPageComponent
  },
  { path: 'gather', loadChildren: () => import(`./gather/gather.module`).then(m => m.GatherModule) },
  {
    path: 'double-opt-in/confirm',
    component: DoubleOptInConfirmComponent
  },
  {
    path: 'pre-interview-questions/:pageState/:orderId',
    component: PreInterviewQuestionsComponent
  },
  {
    path: 'answer-pre-interview-questions',
    component: AnswerPreInterviewQuestionsComponent,
    canActivate: [AuthRequiredGuard]
  },
  {
    path: 'thank-you',
    component: ThankYouComponent
  },
  {
    path: 'job-posting-closed',
    component: JobPostingClosedComponent,
    resolve: { talent: TalentHappyPathAuthResolver }
  },
  { path: 'myaquent',
    loadChildren: () => import(`./talent-happy-path/quick-apply/quick-apply.module`).then(m => m.QuickApplyModule),
    data: { isGeneralApplication: false }
  },
  { path: 'quick-apply/account',
    loadChildren: () => import(`./talent-happy-path/quick-apply/quick-apply.module`).then(m => m.QuickApplyModule),
    data: { isGeneralApplication: true }
  },
  { path: 'quick-apply/:postingId',
    loadChildren: () => import(`./talent-happy-path/quick-apply/quick-apply.module`).then(m => m.QuickApplyModule),
    data: { isGeneralApplication: false }
  },
  { path: 'talent-profile/:postingId', loadChildren: () => import('./talent-happy-path/talent-profile/talent-profile.module').then(m => m.TalentProfileModule) },
  { path: 'talent-profile', loadChildren: () => import('./talent-happy-path/talent-profile/talent-profile.module').then(m => m.TalentProfileModule) },
  { path: 'initial-interview', loadChildren: () => import('./talent-happy-path/initial-interview/initial-interview.module').then(m => m.InitialInterviewModule) },
  { path: 'vms-submittal/:postingId', loadChildren: () => import('./talent-happy-path/vms-submittal/vms-submittal.module').then(m => m.VmsSubmittalModule) },
  { path: 'talent-availability/email/cancellation/:obfuscatedTalentId', component: EmailCancellationComponent },
  { path: 'collect', loadChildren: () => import('./collect-ai-data/collect-ai-data.module').then(m => m.CollectAiDataModule) },
  { path: 'milton', loadChildren: () => import('./portfolio-collect/portfolio-collect.module').then(m => m.PortfolioCollectModule) },
  {
    path: '**',
    component: BadUrlComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
